import React from "react";
import { Link } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";

const CenteredContainer = styled.div`
  ${tw`flex flex-col flex-grow items-center justify-center mx-auto px-[15px] w-full`}
  max-width: 1140px;
`;
const TextCenter = styled.div`
  ${tw`text-center justify-center`}
`;
const GreenHeading = styled.h4`
  ${tw`justify-center`}
  color: #33aa44;
`;
const CenteredParagraph = styled.p`
  ${tw`text-center justify-center`}
`;
const PrimaryButtonLink = styled(Link)`
  ${tw`inline-block font-normal text-center align-middle cursor-pointer text-white no-underline`}
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  background-color: #007bff;
  border: 1px solid #007bff;
  transition: all 0.15s ease-in-out;

  &:hover {
    background-color: #0069d9;
    border-color: #0062cc;
    color: #fff;
  }
`;

const Thanks = () => (
  <CenteredContainer>
    <TextCenter>
      <GreenHeading>Thank you for registering</GreenHeading>
      <CenteredParagraph>
        Please check your inbox (or maybe spam folder) for your confirmation
        email and confirm within 7 days.
      </CenteredParagraph>

      <div className="actions">
        <PrimaryButtonLink to="/dashboard">Get Dwellin!</PrimaryButtonLink>
      </div>
    </TextCenter>
  </CenteredContainer>
);

export default Thanks;
